import { notificationIds } from '$stores';
import { get } from 'svelte/store';
import { client } from '$lib/api/Client';
import type { Notification } from '$shared/lib';

/**
 * Marks the clicked notification (and any other "seen" notifications) as read immediately
 */
export async function handleNotificationClick(notification: Notification) {
  try {
    // 1) Add the clicked notification's ID to the store if it's not already there
    const currentIds = get(notificationIds) ?? [];
    if (!currentIds.includes(notification.id)) {
      notificationIds.set([...currentIds, notification.id]);
    }

    // 2) Mark ALL notifications currently in the store as read
    //   (this includes the newly clicked one plus anything that was seen via IntersectionObserver)
    await client.notifications.markAsRead(get(notificationIds));
  } catch (error) {
    console.error('Error marking notification(s) as read:', error);
  }
}
